const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  items: [],
  error: null,
  nbResult: 0,
  paginationPage: 1,
  paginationTotalPages: 1,
  openDeleteAlbum: false,
  currentAlbum: null,
  deleting: false,
  deleted: false
};
export const albumReducer = (state = initialState, action) => {
  switch (action.type) {
    case `RESET_ALBUMS`: {
      return initialState;
    }
    case `FETCH_ALBUMS_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_ALBUMS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data.map(d => {
          if (d.medias) {
            d.medias = d.medias.map(i => ({ ...i, inAlbum: true }));
          }
          return d;
        }),
        nbResult: nbResult
      };
    }
    case `FETCH_ALBUMS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case `SAVE_ALBUM_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_ALBUM_FULFILLED`: {
      const { data } = action.payload.data;

      const album = state.items.find(item => item.id === data.id);
      if (!album) {
        // new uploaded media
        return {
          ...state,
          saving: false,
          saved: true,
          items: [data, ...state.items],
          nbResult: state.nbResult + 1
        };
      }

      const newMedia = { ...album, ...data };
      const newMedias = state.items.map(item => {
        return item.id === newMedia.id ? newMedia : item;
      });

      return {
        ...state,
        items: newMedias
      };
    }
    case `SAVE_ALBUM_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        saved: false,
        error
      };
    }
    case `SAVE_MEDIA_FULFILLED`: {
      const { data } = action.payload.data;

      if (
        !data ||
        !state.items.find(i => i.medias && i.medias.find(m => m.id === data.id))
      ) {
        return state;
      }

      const items = state.items.map(item => {
        if (item.medias && item.medias.find(m => m.id === data.id)) {
          return {
            ...item,
            medias: item.medias.map(m => {
              if (m.id === data.id) {
                return {
                  ...m,
                  ...data
                };
              }
              return m;
            })
          };
        }

        return item;
      });

      return {
        ...state,
        items
      };
    }
    case `FETCH_INFINITE_ALBUMS_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_INFINITE_ALBUMS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;

      // Ovoid duplicates
      const newItems = (data || []).filter(newItem => {
        return !state.items.find(item => item.id === newItem.id);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: state.items.concat(newItems),
        nbResult: nbResult
      };
    }
    case `FETCH_INFINITE_ALBUMS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case `SET_ALBUMS`: {
      return { ...state, items: [...action.albums] };
    }

    case `SET_ALBUM`: {
      return { ...state, currentAlbum: action.album };
    }

    case `SET_OPEN_DELETE_ALBUM`: {
      return { ...state, openDeleteAlbum: action.payload };
    }

    case `DELETE_ALBUM_PENDING`: {
      return { ...state, deleting: true, deleted: false };
    }
    case `DELETE_ALBUM_FULFILLED`: {
      return {
        ...state,
        items: state.items.filter(item => item.id !== state.currentAlbum.id),
        currentAlbum: null,
        deleted: true,
        deleting: false,
        error: null
      };
    }
    case `DELETE_ALBUM_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        deleting: false,
        deleted: false,
        error
      };
    }

    case "FETCH_ALBUM_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ALBUM_FULFILLED": {
      const { data } = action.payload.data;
      return {
        ...state,
        fetching: false,
        currentAlbum: data.length === 1 ? data[0] : null
      };
    }
    case "FETCH_ALBUM_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    default:
      return state;
  }
};

const albumEditorInitialState = {
  isOpen: false,
  fetching: false,
  id: null,
  medias: [],
  titleEN: "",
  titleNL: "",
  titleFR: "",
  descriptionFR: "",
  descriptionEN: "",
  descriptionNL: "",
  tags: []
};

export const albumEditorReducer = (state = albumEditorInitialState, action) => {
  switch (action.type) {
    case "CLOSE_ALBUM_EDITOR": {
      return initialState;
    }
    case "OPEN_ALBUM_EDITOR": {
      return {
        ...state,
        isOpen: true
      };
    }
    case "SET_ALBUM_EDITOR": {
      return { ...state, ...action.albumEditor };
    }
    case "RESET_ALBUM_EDITOR": {
      return albumEditorInitialState;
    }
    case "REMOVE_MEDIA_FROM_ALBUM_MEDIAS": {
      return {
        ...state,
        medias: state.medias.filter(media => media.id !== action.id)
      };
    }
    case "FETCH_ALBUM_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ALBUM_FULFILLED": {
      const { data } = action.payload.data;
      if (data.length === 1)
        return {
          ...state,
          fetching: false,
          id: data[0]["id"],
          medias: data[0]["medias"],
          titleEN: data[0]["titleEn"],
          titleNL: data[0]["titleNl"],
          titleFR: data[0]["titleFr"],
          descriptionFR: data[0]["descriptionFr"],
          descriptionEN: data[0]["descriptionEn"],
          descriptionNL: data[0]["descriptionNl"],
          tags: data[0]["tags"]
        };
      else
        return {
          fetching: false,
          id: null,
          medias: [],
          titleEN: "",
          titleNL: "",
          titleFR: "",
          descriptionFR: "",
          descriptionEN: "",
          descriptionNL: "",
          tags: []
        };
    }
    case "FETCH_ALBUM_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case "SET_EDITOR_ALBUM": {
      return {
        ...state,
        id: action.payload.id,
        medias: action.payload.medias,
        titleEN: action.payload.titleEn,
        titleNL: action.payload.titleNl,
        titleFR: action.payload.titleFr,
        descriptionFR: action.payload.descriptionFr,
        descriptionEN: action.payload.descriptionEn,
        descriptionNL: action.payload.descriptionNl,
        tags: action.payload.tags ? action.payload.tags : []
      };
    }

    case "DELETE_EDITOR_MEDIA": {
      return {
        ...state,
        medias: state.medias.filter(media => media.id !== action.payload.id)
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/album.js